import { httpRequest } from '@calendly/http-tools'

const MAX_PAGE_SIZE = 100

export const getOrganizationMemberships = (
  query,
  userGroupId = null,
  filterForGroupAdmin = false,
  includeOnlyGroupMembers = false,
  pageSize = MAX_PAGE_SIZE,
) => httpRequest({
  url: '/api/organization/memberships',
  method: 'GET',
  params: {
    filter_term: query,
    page_size: pageSize,
    filter_for_group_admin: filterForGroupAdmin,
    include_only_group_members: includeOnlyGroupMembers,
    user_group_id: userGroupId,
  }
})

export const getOrganizationInvitations = (
  query,
  userGroupId = null,
  filterForGroupAdmin = false,
  includeOnlyGroupMembers = false,
) => httpRequest({
  url: '/api/organization/invitations',
  method: 'GET',
  params: {
    filter_term: query,
    status: 'pending',
    sort_field: 'email',
    sort_order: 'asc',
    page_size: MAX_PAGE_SIZE,
    filter_for_group_admin: filterForGroupAdmin,
    user_group_id: userGroupId,
    include_only_group_members: includeOnlyGroupMembers
  }
})

export const getUserGroups = (
  query,
  _userGroupId = null,
  _filterForGroupAdmin = false,
  _includeOnlyGroupMembers = false,
  userGroupIds = [],
  pageSize = MAX_PAGE_SIZE,
) => httpRequest({
  url: '/api/organization/user_groups',
  method: 'GET',
  params: {
    filter_term: query,
    sort_field: 'name',
    sort_order: 'asc',
    page_size: pageSize,
    user_group_ids: userGroupIds
  }
})

export const getMigrations = (query) => httpRequest({
  url: '/api/organization/migrations',
  method: 'GET',
  params: {
    filter_term: query,
    sort_field: 'name',
    sort_order: 'asc',
    page_size: MAX_PAGE_SIZE
  }
})

export const getOrganizationMembershipsByIds = (ids) => httpRequest({
  url: '/api/organization/memberships',
  method: 'GET',
  params: {
    membership_ids: ids,
    sort_field: 'name',
    sort_order: 'asc',
    page_size: MAX_PAGE_SIZE
  }
})

export const getOrganizationInvitationsByIds = (ids) => httpRequest({
  url: '/api/organization/invitations',
  method: 'GET',
  params: {
    invitation_ids: ids,
    status: ['pending', 'migrating'],
    sort_field: 'email',
    sort_order: 'asc',
    page_size: MAX_PAGE_SIZE
  }
})

export const getUserGroupsByIds = (ids) => httpRequest({
  url: '/api/organization/user_groups',
  method: 'GET',
  params: {
    user_group_ids: ids,
    sort_field: 'name',
    sort_order: 'asc',
    page_size: MAX_PAGE_SIZE
  }
})

export const getMigrationsByIds = (ids) => httpRequest({
  url: '/api/organization/migrations',
  method: 'GET',
  params: {
    migration_ids: ids,
    sort_field: 'name',
    sort_order: 'asc',
    page_size: MAX_PAGE_SIZE
  }
})
